var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"gst-toggle-input",class:{
        'gst-toggle-input--checked': _vm.value,
        'gst-toggle-input--disabled': _vm.disabled,
    },on:{"click":function($event){!_vm.disabled && _vm.$emit('input', !_vm.value)}}},[_c('span',{staticClass:"gst-toggle-input__switch",class:{
            'gst-toggle-input__switch--checked': _vm.value,
        }},[_vm._t("switch")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }